import type { OptionsDocument, PresentationOption, QuoteDocument } from 'paintscout'
import { getDefaultPresentation } from '../../../options/presentation/get-default-presentation'
import { isPresentationV2Doc } from '../is-presentation-next'
import { getQuotePresentation } from './get-quote-presentation'

/**
 * Resolves a quote's presentation for the **v1** renderer, guaranteeing a v1-shaped document.
 *
 * getQuotePresentation returns whichever version is assigned, but the v1 renderer indexes
 * `pages[].sections[]` directly — hand it a v2 document (`pages[].sections[].blocks[]`) and it
 * renders empty sections rather than failing. Callers that branch on version (customer-view Index,
 * QuotePreviewDialog — see #21310) never get here; anything reaching this function with a v2 doc is
 * a routing bug, so it falls back to the default presentation and logs rather than degrading
 * silently. Same treatment getQuotePresentation already gives a page-less template.
 */
export function getQuoteV1Presentation(args: {
  options: OptionsDocument
  quote: QuoteDocument
  inactive?: boolean
  isWorkOrder?: boolean
  isProductOrderForm?: boolean
  current?: boolean
}): PresentationOption {
  const presentation = getQuotePresentation(args)

  if (isPresentationV2Doc(presentation)) {
    console.warn(
      `getQuoteV1Presentation: presentation "${presentation.key}" is v2-shaped but reached the v1 ` +
        `renderer; falling back to the default presentation`
    )
    return getDefaultPresentation({ options: args.options, invoice: args.quote?.is_invoice })
  }

  return presentation
}
